var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.pagePending && _vm.accessToRoutedView)?_c('Layout',[_c('RouterView')],1):_c('Loader',{attrs:{"size":50,"color":"goodin"}})
}
var staticRenderFns = []

export { render, staticRenderFns }